export const delay = async (duration: number) =>
  new Promise((r) => setTimeout(r, duration));
